import {
    FETCH_ALL_PROJECT_LIST,
    FETCH_PROJECT_DOCUMENT,
    FETCH_PROJECT_BACKGROUND_INFORMATION,
    FETCH_MAIN_QUOTATION,
    FETCH_DOCUMENT_LIST,
    FETCH_DOCUMENT_CONTENT,
    FETCH_TEMPLATE_CONTENT,
    FETCH_PROJECT_SUMMARY,
    UPDATE_ITEM_LIST,
    UPDATE_UNIT_LIST,
    UPDATE_AVILABLE_CONTACT_PERSON_LIST,
    UPDATE_ITEM_SMART_SUGGESTION_LIST,
    UPDATE_PROJECT_DOCUMENT_DUE,
    REQUEST_REDIRECT
} from '../ActionTypes'

const INITIAL_STATE = {
    selectedProjectDocument: {},
    projectSummary: [],
    importedBackgroundInformation: {},
    mainQuotation: {},
    allProjectList: [],
    documentList: [],
    importedDocument: {},
    importedTempalte: {},
    itemList: [],
    unitList: [],
    availableContactMemberList: [],
    itemSmartSuggestionList: {
        loading: false,
        keyword: '',
        suggestionList: []
    },
    redirectRequest: ''
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_PROJECT_DOCUMENT:
            return { ...state, selectedProjectDocument: action.payload }
        case FETCH_PROJECT_BACKGROUND_INFORMATION:
            return { ...state, importedBackgroundInformation: action.payload }
        case FETCH_MAIN_QUOTATION:
            return { ...state, mainQuotation: action.payload }
        case FETCH_DOCUMENT_LIST:
            return { ...state, documentList: action.payload }
        case FETCH_ALL_PROJECT_LIST:
            return { ...state, allProjectList: action.payload }
        case FETCH_DOCUMENT_CONTENT:
            return { ...state, importedDocument: action.payload }
        case FETCH_TEMPLATE_CONTENT:
            return { ...state, importedTempalte: action.payload }
        case FETCH_PROJECT_SUMMARY:
            return { ...state, projectSummary: action.payload }
        case UPDATE_ITEM_LIST:
            return { ...state, itemList: action.payload }
        case UPDATE_UNIT_LIST:
            return { ...state, unitList: action.payload }
        case UPDATE_AVILABLE_CONTACT_PERSON_LIST:
            return { ...state, availableContactMemberList: action.payload }
        case UPDATE_ITEM_SMART_SUGGESTION_LIST:
            return { ...state, itemSmartSuggestionList: action.payload }
        case UPDATE_PROJECT_DOCUMENT_DUE:
            return { ...state, selectedProjectDocument: { ...state.selectedProjectDocument, due: action.payload } }
        case REQUEST_REDIRECT:
            return { ...state, redirectRequest: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/ProjectDocumentPage/ProjectDocumentPageReducer.js